import React, { useState, useEffect } from 'react'
import { Modal, Icon, Empty, Button } from 'antd';
import styles from './index.less';

let tempTimer = null;
export default function PreviewModal(props) {

  const { title, imgArray, visible, onCancel } = props;
  const [index,setIndex] = useState(0);
  const [nextDisabled,setNextDisabled] = useState(true);
  const [lastDisabled,setLastDisabled] = useState(true)
  const [showToolBtn,setShowToolBtn] = useState(false);
  let num = 1;
  //https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3649178992,1821853682&fm=26&gp=0.jpg
  //https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=3023806798,280362912&fm=26&gp=0.jpg
  useEffect(()=>{
    if(index === imgArray.length - 1){
      setNextDisabled(true);
    }

    return ()=>{
      if(tempTimer){
        clearTimeout(tempTimer);
      }
    }
  },[])


  useEffect(() => {
    if(index === 0){
      setLastDisabled(true);
    }else{
      setLastDisabled(false)
    }

    if(index === imgArray.length - 1){
      setNextDisabled(true);
    }else{
      setNextDisabled(false);
    }
  }, [index,imgArray])

  const next = ()=>{
    let [dom] = document.getElementsByClassName('img-content');
    if(dom){
      dom.style.opacity = 0;
      dom.style.transition = 'all 0.1s';
      setTimeout(() => {
        dom.style.opacity = 1;
        dom.style.transition = 'all 0.5s';
        setIndex(index + 1);
      }, 100);
    }
  }

  const last = ()=>{
    let [dom] = document.getElementsByClassName('img-content');
    if(dom){
      dom.style.opacity = 0;
      dom.style.transition = 'all 0.1s';
      setTimeout(() => {
        dom.style.opacity = 1;
        dom.style.transition = 'all 0.5s';
        setIndex(index - 1);
      }, 100);
    }
  }

  const destroy = ()=>{
    setShowToolBtn(false);
    let dom = document.getElementById('bigMask');
    num = 1;
    if(dom){
      dom.style.transform = 'scale(0)';
      dom.style.transition = 'all 0.5s';
    }

    let img = document.getElementById('imgMask');
    if(img){
      img.style.transform = `scale(1)`;
    }
  }

  const dbClick = ()=>{
    let dom = document.getElementById('bigMask');
    if(dom){
      setShowToolBtn(true);
      dom.style.transform = 'scale(1)';
      dom.style.transition = 'all 0.5s';
    }
  }

  const changeBig = ()=>{
    let dom = document.getElementById('imgMask');
    if(dom){
      if(num <= 10){
        dom.style.transform = `scale(${++num})`;
        dom.style.transition = 'all 0.5s';
      }
    }
  }

  const changeSmall = ()=>{
    let dom = document.getElementById('imgMask');
    if(dom){
      if(num > 1){
        dom.style.transform = `scale(${--num})`;
        dom.style.transition = 'all 0.5s';
      }
    }
  }

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={()=>{ onCancel&&onCancel()}}
      footer={null}
      destroyOnClose
      maskClosable={false}
    >
      {imgArray&&imgArray.length > 0?
        <div className={styles.PreviewModalContent}>
          <div className='left-btn'>
            <Button onClick={()=>{last()}} type='link' disabled={lastDisabled}>
              <Icon style={{fontSize:30}} type="left" />
            </Button>
          </div>
          <div className='img-sup' style={{height:300,width:300}}>
            <img onDoubleClick={()=>{dbClick()}} className='img-content'  src={imgArray[index]} alt=''/>
          </div>
          <div className='right-btn'>
            <Button disabled={nextDisabled} onClick={()=>{next()}} type='link' >
              <Icon style={{fontSize:30}} type="right" />
            </Button>
          </div>     

          <div id='bigMask' className='big-preview-mask'>
            <img id='imgMask' src={imgArray[index]} alt=''/>
          </div>
          {showToolBtn?
          <>
            <div className='tool-btn'>
              <Icon onClick={()=>{changeBig()}} style={{fontSize:30,color:'#fff'}} type="plus-circle" />
              <Icon onClick={()=>{changeSmall()}} style={{fontSize:30,marginLeft:20,color:'#fff'}} type="minus-circle" />
            </div>
            <div className='close-btn'>
              <Icon onClick={()=>{destroy()}} style={{fontSize:30,color:'#fff'}}  type="close" />
            </div>
          </>
          :''}
            
        </div>
        :
        <Empty />
      }
      
    </Modal> 
  )
}
